import React, { useState } from "react";

import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { Accordion } from "react-bootstrap";
import Banner from "../../../../assets/images/Rounds/statusTopBanner.png";
import ReactPlayer from "react-player";
const EditPostStarAudition = () => {
  const [convertedContent, setConvertedContent] = useState();

  const [imageData, setImageData] = useState("");
  const [fileVideo, setFileVideo] = useState("");
  const [file, setFile] = useState("");
  const [pdfFile, setPdfFile] = useState("");
  const [pdfData, setPdfData] = useState("");

  const handleChange = (file) => {
    setFile(URL.createObjectURL(file[0]));
    setImageData(file[0]);
  };
  const handleVideoChange = (file) => {
    setFileVideo(file[0]);
  };
  const handlePdfChange = (file) => {
    setPdfFile(URL.createObjectURL(file[0]));
    setPdfData(file[0]);
  };

  return (
    <>
      <div className="row mx-1 bg-dark py-4 mt-4 mb-5">
        <div className="row mb-3">
          <div className="col-md-2 text-light fw-bold mb-1">Description</div>
          <div className="col-md-10">
            <CKEditor
              name=""
              data=""
              editor={ClassicEditor}
              onChange={(event, editor) => {
                setConvertedContent(editor.getData());
              }}
            />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-md-2 text-light fw-bold mb-1">Upload Image</div>
          <div className=" row col-md-3">
            <div className="imhj">
              <img src={file} alt="img-fluid" className="MoImg" width="100%" />
            </div>
            <div className="vg">
              <input
                type="file"
                name="file"
                id="file"
                className="inputfile w-25"
                onChange={(e) => handleChange(e.target.files)}
              />
              <label for="file">
                <i className="fas fa-cloud-upload-alt"></i> Upload Image
              </label>
            </div>
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-md-2 text-light fw-bold mb-1">Upload Video</div>
          <div className=" row col-md-3">
            <div className="imhj">
              <ReactPlayer url={fileVideo} className="jxk" width="100%" />
            </div>
            <div className="vg">
              <input
                type="file"
                name="file"
                id="setFile"
                className="inputfile w-25"
                onChange={(e) => handleVideoChange(e.target.files)}
              />
              <label for="file">
                <i className="fas fa-cloud-upload-alt"></i> Upload Video
              </label>
            </div>
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-md-2 text-light fw-bold mb-1">Upload PDF</div>
          <div className="d-flex text-light col-md-4">
            <span className="me-2 pt-1">{pdfData}</span>
            <input
              type="file"
              name="file"
              id="file"
              className="inputfile w-25"
              onChange={(e) => handlePdfChange(e.target.files)}
            />
            <label for="file">
              <i className="fas fa-cloud-upload-alt"></i> Upload PDF
            </label>
          </div>
        </div>
        <div className="d-flex mt-4 mb-3 justify-content-center">
          {/* <button className="btn bg-danger text-light  py-2 me-3 px-3 fw-bold">
                                                  Rejected
                                             </button>
                                             <button className="btn bg-warning text-light  px-3 py-2 me-3 fw-bold">
                                                  View  <i className="fa fa-eye"></i>
                                             </button> */}

          <button className="btn bg-info text-light px-3  py-2  fw-bold">
            Update
          </button>
        </div>
      </div>
    </>
  );
};

export default EditPostStarAudition;
